module.exports = __webpack_public_path__ + "static/img/icon-left.1725acf0.png";